import React from 'react';
import ErpTemplate from '../../components/ErpTemplate';

/**
 * Page Not Found (404) padrão.
 *
 * Mantém o layout do sistema (navbar/sidebar via ErpTemplate) e mostra apenas
 * um texto cinza claro, centralizado.
 */
export default function NotFound() {
    return (
        <ErpTemplate>
            <div
                className="main-content container-fluid"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '70vh' }}
            >
                <h2 style={{ color: '#c2c2c2', fontWeight: 400, textAlign: 'center', margin: 0 }}>
                    404 | Página não encontrada
                </h2>
            </div>
        </ErpTemplate>
    );
}
